import React, { Component } from 'react';
import { connect } from 'react-redux';

import InputMaterial from '../../../components/UI/InputMaterial/InputMaterial';
import CommonList from '../Common/CommonList/CommonList';
import CommonListItem from '../Common/CommonList/CommonListItem/CommonListItem';
import CommonTag from '../Common/CommonTag/CommonTag';
import Button from '../../UI/Button/Button';

import * as paymentActions from '../../../store/actions/index';
import { setAmountDetails } from '../../../store/actions/index';
import EMIFooter from '../EMI/EMIFooter/EMIFooter';

class UPI extends Component {

    componentWillMount() {
        this.props.onSetAmountDetails(this.props.upiPayment.UPI);
    }   

    render() {
        return (
            <React.Fragment>
                <div>
                    <div className={`u-flex justify-content-between align-items-center mb-6 u-height60`}>
                        <InputMaterial 
                            type='text'
                            label='Virtual Payment Address'
                            alignment='left'
                            onChange={(e) => {
                                this.props.onSetUpiPin(e.target.value)
                            }}
                            value={this.props.pin}
                            name='cardName'/>
                    </div>
                    <div className={`mb-3`}>
                        <CommonTag>Note:</CommonTag>
                    </div>
                    <CommonList>
                        <CommonListItem>Enter your vpa and click on pay now</CommonListItem>
                        <CommonListItem>You will receive a payment request from Yatra in your UPI App</CommonListItem>
                        <CommonListItem>Enter mpin on your UPI app to authorize payment</CommonListItem>
                    </CommonList>
                </div>
                <div className={`u-flex justify-content-between align-items-center mt-auto phone-f-column`}>
                    <div className={`u-phoneWidth100Percent phone-mb-4`}>
                        <EMIFooter/>
                    </div>
                    <div className={`u-phone-width100Percent`}> 
                        <Button onClick={this.payButtonHandler} theme='Primary' type='Pay'>Pay Now</Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        pin: state.payments.upiPin,
        upiPayment: state.payments.bookingDetails.agentPaymentOptions.amountDetails.UPI
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetUpiPin: (pin) => dispatch(paymentActions.setUpiPin(pin)),
        onSetAmountDetails: (val) => dispatch(setAmountDetails(val))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UPI);


// WEBPACK FOOTER //
// ./src/components/Payment/UPI/UPI.js